import type { NavigationGuard } from "vue-router";

import { useUserStore } from "@/App/user/user.store";
import { useNavbarStore } from "../components/AppNavbar/navigation.store";
import { RouteName } from "@/App/router/routeName";
import authService from "@/Pages/Login/services/auth.service";

export const checkRole: NavigationGuard = (to, _from, next) => {
  const userStore = useUserStore();

  if (to.meta.bigBoardAllowed !== true && userStore.isBigBoard) {
    next({ name: RouteName.cases });
    return;
  }

  const navbarStore = useNavbarStore();
  if (
    (to.meta.requiresAuthorization === false && !authService.isLoggedIn()) ||
    navbarStore.accessiblePages.some((link) => link.routeName === to.name)
  ) {
    next();
  } else {
    next({ name: navbarStore.defaultRoute });
  }
};
